<p-select
  [ngModel]="selectedItem()"
  (ngModelChange)="onSelect($event)"
  [options]="options()"
  [disabled]="disabled()"
  [showClear]="true"
  [placeholder]="placeholder() | transloco"
  [appendTo]="appendTo()"
  [class]="styleClass()"
>
  <ng-template pTemplate="selectedItem" let-selectedOption>
    {{ selectedOption?.translations | translateDirectus }}
  </ng-template>

  <ng-template #item let-option>
    {{ option.translations | translateDirectus }}
  </ng-template>
</p-select>
